(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stahlin-goals"] && !Shopify.designMode) return;
  try {
    
function openStahlinGoal() {
  const id = decodeURIComponent(window.location.hash.slice(1));
  if (!id) return;
  const goal = document.getElementById(id);
  if (goal && goal.matches('details.sr-goals__group')) {
    goal.open = true;
    requestAnimationFrame(() => goal.scrollIntoView({block: 'start'}));
  }
}
window.addEventListener('hashchange', openStahlinGoal);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openStahlinGoal);
else openStahlinGoal();

  } catch(e) { console.error(e); }
})();
})();
